'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of wholesale order mobile
 */ const WholesaleOrderMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "51.9236",
                cy: "51.9941",
                rx: "51.9236",
                ry: "51.9941",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.9805",
                y: "68.6482",
                width: "17.5717",
                height: "5.22641",
                rx: "1.61817",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.4757 18.4707H62.9386C64.5704 18.4797 66.1327 19.134 67.285 20.291C68.4373 21.4479 69.0864 23.0139 69.0909 24.6478V78.5341C69.0864 80.171 68.4349 81.7395 67.2789 82.8969C66.1229 84.0544 64.5563 84.7066 62.9214 84.7112H40.4585C38.8237 84.7066 37.2571 84.0544 36.1011 82.8969C34.945 81.7395 34.2936 80.171 34.2891 78.5341V66.6819V59.0538V57.1803V24.6478C34.2936 23.0079 34.9474 21.4368 36.1071 20.2789C37.2669 19.1209 38.8379 18.4707 40.4757 18.4707Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3176 68.7363H45.0961C43.6882 68.7363 42.5469 69.879 42.5469 71.2887C42.5469 72.6983 43.6882 73.841 45.0961 73.841H58.3176C59.7255 73.841 60.8668 72.6983 60.8668 71.2887C60.8668 69.879 59.7255 68.7363 58.3176 68.7363Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.7891",
                y: "73.8242",
                width: "6.03885",
                height: "5.91267",
                rx: "2.95633",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.9727",
                y: "21.4121",
                width: "29.6575",
                height: "48.9139",
                rx: "1.98447",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.054 43.4716V42.5551C47.4179 42.5551 47.7129 42.2601 47.7129 41.8962V41.6584C47.7129 41.1956 47.3377 40.8203 46.8748 40.8203H42.5126C42.0498 40.8203 41.6745 41.1956 41.6745 41.6584V41.8962C41.6745 42.2601 41.9695 42.5551 42.3334 42.5551V43.4851C41.9719 43.6173 41.6601 43.8552 41.4399 44.1667C41.2197 44.4783 41.1016 44.8486 41.1016 45.2281V51.0003C41.1016 51.4632 41.4768 51.8384 41.9397 51.8384H47.4876C47.9505 51.8384 48.3257 51.4632 48.3257 51.0003V45.2289C48.3257 44.8423 48.2032 44.4653 47.9753 44.1504C47.7474 43.8354 47.4254 43.5981 47.054 43.4716Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.6328",
                y: "40.8301",
                width: "6.23904",
                height: "1.77561",
                rx: "0.52019",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.0345 57.8309V56.9145C47.3984 56.9145 47.6934 56.6195 47.6934 56.2556V56.0178C47.6934 55.5549 47.3182 55.1797 46.8553 55.1797H42.4931C42.0302 55.1797 41.655 55.5549 41.655 56.0178V56.2556C41.655 56.6195 41.95 56.9145 42.3139 56.9145V57.8445C41.9523 57.9767 41.6405 58.2145 41.4204 58.5261C41.2002 58.8376 41.0821 59.208 41.082 59.5874V65.3597C41.082 65.8226 41.4573 66.1978 41.9202 66.1978H47.4681C47.9309 66.1978 48.3062 65.8226 48.3062 65.3597V59.5883C48.3062 59.2017 48.1837 58.8247 47.9558 58.5097C47.7279 58.1948 47.4058 57.9575 47.0345 57.8309Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.625",
                y: "55.1875",
                width: "6.23904",
                height: "1.77561",
                rx: "0.52019",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.0462 29.1805V28.2641C47.4101 28.2641 47.7051 27.9691 47.7051 27.6052V27.3674C47.7051 26.9045 47.3299 26.5293 46.867 26.5293H42.5048C42.0419 26.5293 41.6667 26.9045 41.6667 27.3674V27.6052C41.6667 27.9691 41.9617 28.2641 42.3256 28.2641V29.1941C41.9641 29.3263 41.6523 29.5642 41.4321 29.8757C41.2119 30.1873 41.0938 30.5576 41.0938 30.9371V36.7093C41.0938 37.1722 41.469 37.5474 41.9319 37.5474H47.4798C47.9427 37.5474 48.3179 37.1722 48.3179 36.7093V30.9379C48.3179 30.5513 48.1954 30.1743 47.9675 29.8593C47.7396 29.5444 47.4176 29.3071 47.0462 29.1805Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.625",
                y: "26.5508",
                width: "6.23904",
                height: "1.77561",
                rx: "0.52019",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "28.3477",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "42.5098",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "56.9805",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "31.0625",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "45.2305",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "51.0273",
                y: "59.6953",
                width: "9.93321",
                height: "1.20566",
                rx: "0.60283",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.WholesaleOrderMobile = WholesaleOrderMobile;
//# sourceMappingURL=WholesaleOrderMobile.cjs.map
